// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"10fdc3b5","6850":"d470442a"}[chunkId] + ".chunk.css";
};